export default __webpack_public_path__ + "static/media/play.10534052.svg";